module.exports = __webpack_public_path__ + "static/media/congnitive.558f61c5.jpg";